// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"Banner_sliderWrapper__GEoOM","bannerImage":"Banner_bannerImage__K5LgK"};